import '../assets/Modal.css';
import { defineComponent, openBlock, createElementBlock, unref, createElementVNode, createVNode, withModifiers } from 'vue';
import { d as debounce } from './debounce.CJgNZ1TL.js';
import { u as useI18n } from './widgets-core.es.C7uAbUpp.js';
import { _ as _sfc_main$1 } from './XClose.vue_vue_type_style_index_0_lang.8cS4YnbD.js';
import { t as toggleModal } from './useModal.CtQMkYkB.js';

const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Modal",
  props: {
    termsText: {}
  },
  setup(__props) {
    const { t } = useI18n();
    const toggleModal$1 = debounce(toggleModal, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-terms__modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": unref(t)("Terms and conditions")
      }, [
        createElementVNode("div", {
          class: "thn--tool-terms__modal-text",
          innerHTML: _ctx.termsText
        }, null, 8, _hoisted_2),
        createVNode(_sfc_main$1, {
          "only-close-modal": true,
          onMousedown: withModifiers(unref(toggleModal$1), ["left"]),
          onClick: unref(toggleModal$1)
        }, null, 8, ["onMousedown", "onClick"])
      ], 8, _hoisted_1);
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Modal.vue_vue_type_style_index_0_lang.BzBEou5F.js.map
